if (!customElements.get('rga-autumn-home')) {
  customElements.define('rga-autumn-home', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.animations = [];
      this.leaves = [...this.querySelectorAll('.rga-home__leaf img')];
      this.isVisible = false;
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      const copy = this.querySelector('.rga-home__copy');
      const signal = this.abort.signal;
      this.motionPreference.addEventListener('change', () => {
        if (this.motionPreference.matches) this.finish();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.finish();
      }, { signal });
      if (this.dataset.leavesEntered || this.motionPreference.matches || document.hidden || !copy || !this.leaves.length || !('IntersectionObserver' in window) || !Element.prototype.animate) {
        this.finish();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        this.isVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .5);
        if (!this.isVisible) {
          clearTimeout(this.entryTimer);
          this.entryTimer = null;
          if (this.dataset.leavesEntered) this.finish();
          return;
        }
        if (!this.entryTimer && !this.dataset.leavesEntered) {
          this.entryTimer = setTimeout(() => this.enter(), 480);
        }
      }, { threshold: .5, rootMargin: '0px 0px -8% 0px' });
      this.observer.observe(copy);
      this.dataset.leafState = 'ready';
    }
    async enter() {
      clearTimeout(this.entryTimer);
      this.entryTimer = null;
      if (this.dataset.leavesEntered || !this.isVisible) return;
      this.dataset.leavesEntered = 'true';
      const signal = this.abort.signal;
      let timer;
      await Promise.race([
        Promise.all(this.leaves.map(leaf => leaf.decode().catch(() => {}))),
        new Promise(resolve => { timer = setTimeout(resolve, 700); })
      ]);
      clearTimeout(timer);
      if (!this.isConnected || signal.aborted || !this.isVisible || this.dataset.leafState === 'settled' || this.motionPreference.matches || document.hidden || this.leaves.some(leaf => !leaf.complete || !leaf.naturalWidth)) {
        this.finish();
        return;
      }
      this.dataset.leafState = 'entering';
      this.animations = this.leaves.map((leaf, index) => leaf.animate([
        { transform: 'none', easing: 'cubic-bezier(.45, 0, .55, 1)' },
        { transform: `translate3d(${index ? 4 : 6}px, ${index ? -2 : -3}px, 0) rotate(${index ? 2.5 : 2}deg)`, offset: .5, easing: 'cubic-bezier(.45, 0, .55, 1)' },
        { transform: 'none' }
      ], {
        duration: 3400,
        delay: index * 120
      }));
      await Promise.allSettled(this.animations.map(animation => animation.finished));
      this.finish();
    }
    finish() {
      clearTimeout(this.entryTimer);
      this.entryTimer = null;
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.animations = [];
      this.dataset.leavesEntered = 'true';
      this.dataset.leafState = 'settled';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.finish();
      this.abort = null;
    }
  });
}
